import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//高基报表相关API
const basicReport = {
    statistics: {
        yearOption: config => createAPI('/student/statistics/yearOption', 'post', config),
        deptOption: config => createAPI('/student/statistics/deptOption', 'post', config),
        majorOption: config => createAPI('/student/statistics/majorOption', 'post', config),
        classOption: config => createAPI('/student/statistics/classOption', 'post', config),
        statusOption: config => createAPI('/student/statistics/statusOption', 'post', config),
        basicList: config => createAPI('/student/statistics/basicList', 'post', config),
        statusList: config => createAPI('/student/statistics/statusList', 'post', config),
    },

    mediumHighBasicReport: {
        queryList: config => createAPI('/basicReport/mediumHighBasicReport/queryList', 'post', config),
        mediumBasic: config => createAPI('/basicReport/mediumHighBasicReport/mediumBasic', 'post', config),
        highBasic: config => createAPI('/basicReport/mediumHighBasicReport/highBasic', 'post', config),
        exportHigh: config => createAPI('/basicReport/mediumHighBasicReport/exportHigh', 'post', config),
        exportMedium: config => createAPI('/basicReport/mediumHighBasicReport/exportMedium', 'post', config),
    }
};

export default basicReport;



// WEBPACK FOOTER //
// ./src/api/modules/basicReport.js